<template>
 <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
    <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
        <div> <img :alt="item.product.name" :src="item.product.picture" class="h-16 w-16 rounded-md mx-auto" /> </div>
    </td>
    <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ item.product.name }}</b></td>
    <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
            <input id="sent" :disabled="CheckExpeditionRecived" type="number" min="0" v-model="item.quantity.sent" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
    </td>
    <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
        <table class="min-w-full">
            <thead>
                <tr>
                    <th class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Ok/Good</th>
                    <th class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Defective</th>
                </tr>
            </thead>
            <tbody class="bg-white"> 
                <tr> 
                    <td class="px-6 py-4 border whitespace-no-wrap"><div class="flex items-center"> <input id="Received" :disabled="CheckExpeditionRecived" type="number" min="0" :max="item.quantity.sent" v-model="item.quantity.received" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" /></div></td>
                    <td class="px-6 py-4 border whitespace-no-wrap"><div class="flex items-center">
                        <input id="Defective" :disabled="CheckExpeditionRecived" type="number" min="0" :max="item.quantity.sent" v-model="item.quantity.defective" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                    </div>
                    </td>    
                </tr>
            </tbody>
        </table>
    </td>
</tr>
</template>
<script>
  export default {
    props: {
        item:Object, 
        CheckExpeditionRecived:Boolean
    },
    data() {
       return {}
    },
    async mounted() {

    },
    watch: {
       'item.quantity': {
        handler(newValue) {
            if(newValue.received){
                if(!this.validQte(newValue.received)) this.item.quantity.received=0;
                else  this.item.quantity.received=parseInt( this.item.quantity.received, 10);
            }else this.item.quantity.received=0;
            if(newValue.defective){
               if(!this.validQte(newValue.received)) this.item.quantity.defective=0;
               else this.item.quantity.defective=parseInt( this.item.quantity.defective, 10);
            }else this.item.quantity.defective=0;
        },
        deep: true,
    },
    },
    methods: {
      validQte: function (qte) {
         var re = /^\d+$/;
        return re.test(qte);
    },
    }

  }
</script>      